import { DecisionWriteRight } from '@pilot-web/exemption-applications'
export const Rights = [
    DecisionWriteRight
]
